/** npm import */
import React, { useRef, useState, useEffect } from 'react'
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

/** local file import */
import Header from '../Layout/header'
import profileCover from '../Assets/profilecover.png'
import qrCodeImage from '../Assets/qrcode.png'
import { DecryptData, ImgEmpty, ImgUrl, NumberChange, NumberOnly, isEmpty } from "../helper/common";
import { ChangeEmailPassword, EnableTFA, GetuserData, SettingsUpdate, userLogin } from "../Axios/user.axios";
import { useDispatch, useSelector } from "react-redux";
import config from '../helper/config';
import delete_png from '../Assets/del.png'
import { Button } from '@mui/material';
import { isAddress } from 'web3-validator';
import Footer from '../Layout/footer';
import Subscriber from '../Layout/subscribe';
import { FaEdit } from "react-icons/fa";
import { RiAddBoxFill } from "react-icons/ri";
import { Cookies } from 'react-cookie';
import { Data_Section } from '../redux/constants';
import CopyToClipboard from "react-copy-to-clipboard";

/** code start */

const initform = {
    UserName: "",
    EmailId: "",
    Profile: "",
    LoginType: "email",
    TFAEnable: false,
    TFACode: "",
    AntiPhishing: false,
    AntiPhishingCode: "",
    WhiteListUser: [],
};

const initname = {
    UserName: "User Name",
    EmailId: "Email-Id",

}

const inittfa = {
    TFAIMage: '', TFASecretCode: '', TFACode: '', Password: '', TFAEnable: false,
}

const Profile = () => {


    const navigate = useNavigate()
    const userdata = useSelector((state) => state?.LoginReducer?.User)
    const cookies = new Cookies();
    const dispatch = useDispatch();


    const [focusedfield, SetFocusedField] = useState([]);
    const [profileImage, setProfileImage] = useState(profileCover);
    const [passwordType, setPasswordType] = useState("password");
    const [passwordType1, setPasswordType1] = useState("password");
    const [enableQR, setEnableQR] = useState(false)

    const [formdata, SetFormdata] = useState(initform);
    const [TFAData, SetTFAData] = useState(inittfa);

    const [displayname, SetDisplayName] = useState(initname);
    const [Error, SetError] = useState({});
    const [Page, SetPage] = useState("register");
    const [counter, setCounter] = useState(120);
    const [Otp, SetOTP] = useState('');
    const [Timer, SetTimer] = useState({
        Minutes: 0,
        Seconds: 0,
    })
    const [DisableStatus, SetDisableStatus] = useState({})
    const [CurrentTab, SetCurrentTab] = useState(1);

    const profileImageRef = useRef(null);

    const handleProfileChange = () => {
        profileImageRef.current.click();
    }

    const togglePassword = () => {
        setPasswordType(passwordType === "password" ? "text" : "password")
    }
    const togglePassword1 = () => {
        setPasswordType1(passwordType1 === "password" ? "text" : "password")
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);

    const OnChange = (e, type) => {
        const { id, value } = e.target;
        SetError({})
        if (type == 'checkbox') {
            SetFormdata({ ...formdata, ...{ [id]: !formdata?.[id] } });
        }
        else if (typeof (type) == 'number') {
            SetFormdata({
                ...formdata,
                ...{
                    WhiteListUser: [
                        ...formdata?.WhiteListUser.slice(0, type),
                        ...[
                            value,
                        ],
                        ...formdata?.WhiteListUser.slice(type + 1, formdata?.WhiteListUser?.length),
                    ],
                },
            })
        }
        else {
            SetFormdata({ ...formdata, ...{ [id]: value } });
        }

    }

    const Validate = (type) => {
        let error = {};
        if (type == 'TFA') {
            if (isEmpty(TFAData?.Password)) {
                error.Password = "Enter Password"
            }
            if (isEmpty(TFAData?.TFACode)) {
                error.TFACode = "Enter 2FA Code"
            }
        }
        else {
            if (isEmpty(formdata?.UserName)) {
                error.UserName = "Enter UserName";
            }
            if (formdata?.AntiPhishing && isEmpty(formdata?.AntiPhishingCode)) {
                error.AntiPhishingCode = "Enter Anti Phishing Code";
            }
            if (formdata?.WhiteListUser?.length > 0) {
                formdata.WhiteListUser.map((val, ind) => {
                    if (isEmpty(val)) {
                        error["whitelist" + ind] = "Wallet Address cannot be Empty";
                    }
                    else if (!isAddress(val)) {
                        error["whitelist" + ind] = "Enter Valid Wallet Address";
                    }
                    else if (formdata?.WhiteListUser.some((test, index) => (test.toLowerCase() == val?.toLowerCase() && ind != index))) {
                        error["whitelist" + ind] = "This Address Already Added";
                    }
                });
            }
        }
        return error
    }

    useEffect(() => {
        if (Page == 'registerverify') {
            if (counter == 0) {
                SetPage('resend');
            }
            const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
            const seconds = String(counter % 60).padStart(2, 0);
            const minutes = String(Math.floor(counter / 60)).padStart(2, 0);
            SetTimer({
                Minutes: minutes,
                Seconds: seconds
            })
            return () =>
                clearInterval(timer);
        }
    }, [counter, Page]);

    useEffect(() => {
        let cookie = ("; " + document.cookie)
            .split(`; ${config.cookiename}=`)
            .pop()
            .split(";")[0];
        if (cookie) {
            GetUserProfile(cookie);
        }
        else {
            navigate('/')
        }
    }, [userdata])

    const GetUserProfile = async (cookie) => {
        let resp = await GetuserData({ data: cookie, kyc: false })
        console.log('GetuserData_resp', resp?.data)
        if (resp?.status) {
            SetFormdata({ ...resp?.data })
            // const twoFactorImage = "https://chart.googleapis.com/chart?chs=130x130&chld=L|0&cht=qr&chl=" + resp?.data?.TFAImageCode;
            const twoFactorImage = resp?.data?.TFAImageCode
            SetTFAData({
                ...TFAData,
                ...{
                    TFAIMage: twoFactorImage,
                    TFAEnable: resp?.data?.TFAEnable,
                    TFASecretCode: DecryptData(resp?.data?.TFACode)

                }
            })
        }
        else {
            navigate('/');
        }
    }

    const OnBlurFn = (e) => {
        const { id, value } = e.target;
        let error = Validate();
        Object.keys(error).map((currkey) => {
            if (currkey == id || focusedfield.includes(currkey)) {
            }
            else {
                delete error[currkey];
            }
        })
        if (focusedfield?.includes(id)) {
        }
        else {
            SetFocusedField([
                ...focusedfield,
                ...[id],
            ])
        }
        SetError(error);
    }

    const TFAOnChange = (e, type) => {
        let id = e?.target?.id;
        let value = e?.target?.value;
        if (type == 'checkbox') {
            SetTFAData({ ...TFAData, ...{ [id]: !TFAData?.[id] } })
            if (TFAData?.TFAEnable && id == "TFAEnable") {
                SetFormdata({
                    ...formdata,
                    ...{
                        TFAEnable: false,
                        LoginType: 'email',
                    }
                })
            }
        }
        else {
            SetTFAData({
                ...TFAData,
                ...{
                    [id]: (id == "TFACode" ? NumberOnly(value) : value),
                }
            })
        }
    }

    const handleFile = (event) => {
        let { id, files } = event.target;
        SetError({ ...Error, ...{ [id]: '' } })
        if (!files?.[0]?.type?.includes('image')) {
            return toast.error("Upload Images Only")
        }
        SetFormdata({
            ...formdata,
            ...{
                [id]: files[0],
            }
        });
    };

    const UserEnbleTFA = async () => {
        SetDisableStatus({ ...DisableStatus, TFA: true });
        let error = Validate('TFA')
        if (isEmpty(error)) {
            let resp = await EnableTFA({ _id: userdata?.payload?._id, Password: TFAData?.Password, TFACode: TFAData?.TFACode })
            console.log('EnableTFA_resp', resp);
            if (resp?.status) {
                SetFormdata({
                    ...formdata,
                    ...{
                        TFAEnable: true,
                        LoginType: 'TFA',
                    }
                })
                GetUserProfile();
                toast.success("2FA Enabled")
            }
            else {
                toast.error(resp?.msg);
            }
        }
        else {
            toast.error(" Fix All Validations.")
            SetError(error);
        }
        SetDisableStatus({ ...DisableStatus, TFA: false });
    }

    const ProfileUpdate = async () => {
        SetDisableStatus({ ...DisableStatus, Update: true });
        let error = Validate();
        if (isEmpty(error)) {
            let senddata = {
                _id: formdata?._id,
                UserName: formdata?.UserName,
                Profile: formdata?.Profile,
                LoginType: formdata?.LoginType,
                TFAEnable: formdata?.TFAEnable,
                AntiPhishing: formdata?.AntiPhishing,
                AntiPhishingCode: formdata?.AntiPhishingCode,
                WhiteListUser: JSON.stringify(formdata?.WhiteListUser),
            }
            let resp = await SettingsUpdate(senddata)
            if (resp?.status) {
                toast.success("Updated Successfully");
                GetUserProfile();
                let cookie = cookies.get(config.cookiename);
                let Resp = await GetuserData({ data: cookie });
                if (Resp?.data) {
                    dispatch({
                        type: Data_Section,
                        Register_Section: {
                            User: {
                                payload: Resp?.data,
                                token: cookie
                            },
                        }
                    })
                }
            }
            else {
                toast.error(resp?.msg);
            }
        }
        else {
            toast.error(" Fix All Validations.")
            SetError(error);
        }
        SetDisableStatus({ ...DisableStatus, Update: false });
    }

    const HideEmailId = (emailid) => {
        try {
            if (typeof (emailid) == 'string') {
                let emailarr = emailid.split('@')
                return emailid.slice(0, 2) + '.......' + emailarr[emailarr.length - 2].slice(-2) + "@" + emailarr[emailarr.length - 1]
            }
            else {
                return emailid
            }
        }
        catch (err) {
            console.log('HideEmailId_error', err)
            return emailid
        }
    }

    const ChangeEmailOrPassword = async (type) => {
        navigate('/edit-' + type)
        // SetDisableStatus({...DisableStatus,[type]:true})
        // let Resp = await ChangeEmailPassword({ EmailId: formdata?.EmailId, type: type, action: 'sendotp' })
        // console.log('ChangeEmailPasswordresp',Resp)
        // if(Resp?.status){
        //     toast.success("OTP sent to "+HideEmailId(formdata?.EmailId))
        // navigate('/edit-'+type)
        // }
        // else{
        //     toast.error(Resp?.msg);
        // }
        // SetDisableStatus({...DisableStatus,[type]:false})
    }

    const AddField = (type) => {
        if (type == "WhiteListUser") {
            if (isEmpty(formdata?.WhiteListUser) || formdata?.WhiteListUser?.length < 10) {
                SetFormdata({
                    ...formdata,
                    ...{
                        WhiteListUser: [...formdata?.WhiteListUser ?? [], ...[""]],
                    },
                })

            } else {
                toast.error("Already added 10 Whitelist Users", 1000);
            }
        }
    };

    const RemoveField = (index, from) => {
        if (from == "WhiteListUser") {
            SetFormdata({
                ...formdata,
                ...{
                    WhiteListUser: [
                        ...formdata?.WhiteListUser.slice(0, index),
                        ...formdata?.WhiteListUser.slice(index + 1, formdata?.WhiteListUser?.length),
                    ],
                },
            })
            //   SetWhiteListUser([
            //     ...WhiteListUser.slice(0, index),
            //     ...WhiteListUser.slice(index + 1, WhiteListUser?.length),
            //   ]);
        }
    };
    const copyText = (a, b) => {
        toast.success('copied');
    }

    return (
        <div>
            <Header />
            <section className='custom_section'>
                <div className='container py-5 py-sm-4 py-md-5'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-sm-11 col-md-9 col-lg-7'>
                            <div className='profile_card'>
                                <h2 className='color-brand-1 mb-15'>Profile</h2>
                                <p class="font-md color-grey-500 mb-4">
                                    Update Your Profile Details Here
                                </p>

                                <form>


                                    <div className='d-flex justify-content-between align-items-center'>
                                        <div>
                                            <div className='profile_wrapper mb-4' onClick={handleProfileChange}>
                                                <img src={ImgEmpty(formdata?.Profile) ? profileImage : typeof (formdata?.Profile) == 'object' ? ImgUrl(formdata?.Profile) : `${config.Img_URL}/profile/${formdata?._id}/${formdata?.Profile}`} />
                                            </div>

                                            <input
                                                type='file'
                                                className='d-none'
                                                ref={profileImageRef}
                                                id='Profile'
                                                onChange={(e) => handleFile(e)} />
                                        </div>

                                        <div>
                                            <h5 className='color-brand-1 mobfont'>Withdraw: {formdata?.MaxWithDraw == 'nolimit' ? (NumberChange(formdata?.WithDrawAmount)) : (NumberChange(formdata?.MaxWithDraw) > 0 ? `${NumberChange(formdata?.WithDrawAmount)} / ${NumberChange(formdata?.MaxWithDraw)}` : "No Withdrawal Available")} (USD)</h5>
                                            {/* <h5 className='color-brand-1'>Withdraw: No Withdrawal Available </h5> */}
                                            <h5 className='color-brand-1 mobfont'>Deposit: {formdata?.MaxDeposit == 'nolimit' ? (NumberChange(formdata?.DepositAmount)) : (NumberChange(formdata?.MaxDeposit) > 0 ? `${NumberChange(formdata?.WithDrawAmount)} / ${NumberChange(formdata?.MaxDeposit)}` : "No Deposit Available")} (USD)</h5>
                                        </div>

                                    </div>


                                    <div className="form-group mb-4">
                                        <input
                                            className={focusedfield?.includes('UserName')
                                                ? (Error?.UserName ? "form-control icon-name is-invalid" :
                                                    "form-control icon-name is-valid") : "form-control icon-name"}
                                            type="text"
                                            name="name"
                                            placeholder="Your name"
                                            onChange={(e) => OnChange(e)}
                                            onBlur={(e) => OnBlurFn(e)}
                                            id='UserName'
                                            disabled={true}
                                            value={formdata?.UserName || ''}
                                        />

                                        {Error?.UserName &&
                                            <span className="error-msg">{Error?.UserName}</span>
                                        }
                                    </div>

                                    <div className="form-group mb-4">
                                        <input
                                            className={"form-control icon-email"}
                                            type="email"
                                            name="EmailId"
                                            placeholder="Your email"
                                            id='EmailId'
                                            disabled={true}
                                            value={HideEmailId(formdata?.EmailId) || ''}
                                        />
                                        {Error?.EmailId &&
                                            <span className="error-msg">{Error?.EmailId}</span>
                                        }

                                    </div>

                                    <div className='boxbg'>
                                        <div className='form-group mb-4'>
                                            <div className='d-flex align-items-center justify-content-between mb-4'>
                                                <label className='form-label mb-0'>Change Email Address</label>
                                                <button type='button' className='btn formbtn py-0' style={{ maxWidth: "200px" }} onClick={() => ChangeEmailOrPassword('email')} disabled={DisableStatus?.email} >
                                                    <FaEdit />
                                                </button>
                                            </div>
                                        </div>
                                        <div className='form-group mb-4'>
                                            <div className='d-flex align-items-center justify-content-between mb-4'>
                                                <label className='form-label mb-0'>Change Password</label>
                                                <button type='button' className='btn formbtn py-0' style={{ maxWidth: "200px" }} onClick={() => ChangeEmailOrPassword('password')} disabled={DisableStatus?.password} >
                                                    <FaEdit />
                                                </button>
                                            </div>
                                        </div>
                                        <div className='form-group'>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <label className='form-label mb-0'>KYC Verification</label>
                                                <button type='button' className='btn formbtn py-0' style={{ maxWidth: "200px" }} onClick={() => navigate('/kyc-verification')} disabled={DisableStatus?.password} >
                                                    <FaEdit />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='d-flex align-items-center gap-3 justify-content-between'>
                                        <label className='mb-0 d-inline-block align-middle font-sm color-grey-500'>Enable 2FA</label>
                                        <div className="custom_toggle">
                                            <label class="switch">
                                                <input
                                                    type="checkbox"
                                                    id="TFAEnable"
                                                    onChange={(e) => { TFAOnChange(e, 'checkbox') }}
                                                    checked={TFAData?.TFAEnable}
                                                />
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>

                                    {(TFAData?.TFAEnable && !formdata?.TFAEnable) ?
                                        <div className='row align-items-xl-center mt-4'>
                                            <div className='col-12 col-xl-8'>
                                                <div>
                                                    <p className='text-small profile_desc'>
                                                        Scan this Qr Code in Authenticator
                                                        Extension for desktop or Authenticator
                                                        Apps (such as Google Authenticator, Twilio Authenticator, etc...)
                                                        for mobile or tablets
                                                    </p>

                                                    <div>
                                                        <label className='fw-bold mb-2 profile_label'>Enter 6 Digit 2FA Code</label>
                                                        <div className="form-group mb-4">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                placeholder="Enter your code"
                                                                id="TFACode"
                                                                onChange={(e) => { TFAOnChange(e) }}
                                                                maxLength='6'
                                                                value={TFAData?.TFACode}
                                                            />
                                                            {Error?.TFACode && (
                                                                <span className="error-msg">{Error.TFACode}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label className='fw-bold mb-2 profile_label'>Enter Password</label>
                                                        <div className="form-group position-relative mb-4">
                                                            <input
                                                                className={focusedfield?.includes('Password')
                                                                    ? (Error?.Password ? "form-control icon-password input-green-bd is-invalid"
                                                                        : "form-control icon-password input-green-bd is-valid")
                                                                    : "form-control icon-password input-green-bd"}
                                                                type={passwordType}
                                                                placeholder="Enter your Password"
                                                                onChange={(e) => { TFAOnChange(e) }}
                                                                value={TFAData?.Password}
                                                                id='Password'
                                                            />
                                                            <div onClick={togglePassword}>
                                                                {passwordType == "text" ?
                                                                    <FaRegEye className="eyepassword" /> :
                                                                    <FaRegEyeSlash className="eyepassword"
                                                                    />}
                                                            </div>

                                                            {Error?.Password && (
                                                                <span className="error-msg">{Error.Password}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <button className="btn btn-brand-lg btn-full font-md-bold" type="button" onClick={() => UserEnbleTFA()} disabled={DisableStatus?.TFA} >Enable 2FA</button>
                                                </div>
                                            </div>
                                            <div className='col-12 col-xl-4 d-flex justify-content-xl-end'>
                                                <div className='profile_qr_wrapper mb-4'>
                                                    <img src={TFAData?.TFAIMage} alt='qrcode' />

                                                </div>
                                            </div>

                                            <>
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                    <span>Copy a 2FA Code - {TFAData?.TFASecretCode}</span>
                                                    <CopyToClipboard text={TFAData?.TFASecretCode} >
                                                        <span
                                                            onClick={() => copyText(TFAData?.TFASecretCode)}
                                                            style={{ cursor: "pointer", color: "#0d6efd" }}
                                                        >
                                                            {/* 📄 */}
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="18"
                                                                height="18"
                                                                fill="currentColor"
                                                                viewBox="0 0 16 16"
                                                            >
                                                                <path d="M10 1H3a2 2 0 0 0-2 2v9h1V3a1 1 0 0 1 1-1h7V1z" />
                                                                <path d="M13 3H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z" />
                                                            </svg>
                                                        </span>
                                                    </CopyToClipboard>
                                                </div>
                                            </>

                                        </div>
                                        : null
                                    }

                                    <div className='d-flex align-items-center gap-3 mb-4 justify-content-between mt-4'>
                                        <p className='mb-0 d-inline-block align-middle font-sm color-grey-500'>Enable Anti-Phising</p>
                                        <div className="custom_toggle">
                                            <label class="switch">
                                                <input
                                                    type="checkbox"
                                                    id="AntiPhishing"
                                                    onChange={(e) => { OnChange(e, 'checkbox') }}
                                                    checked={formdata?.AntiPhishing}
                                                />
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>

                                    {formdata?.AntiPhishing ?
                                        <div className='row align-items-xl-center'>
                                            <div className='col-12 col-xl-12'>
                                                <div>
                                                    <p className='text-small profile_desc'>
                                                        This Code Will be Sent to Your Email if Mail  is Sent From Our Website
                                                    </p>

                                                    <div>
                                                        <label className='fw-bold mb-2 profile_label'>Anti Phising Code</label>
                                                        <div className="form-group mb-4">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                placeholder="Enter your Anti Phising code"
                                                                id="AntiPhishingCode"
                                                                onChange={(e) => { OnChange(e) }}
                                                                value={formdata?.AntiPhishingCode}
                                                            />

                                                            {/* <span className="error-msg">error</span> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <></>
                                    }

                                    <div className="form-group mb-4 mt-4">
                                        <div className="d-flex align-items-center justify-content-between mb-4">
                                            <label className="form-label mb-0">Add Whitelist User</label>
                                            <Button
                                                type="button"
                                                className="btn formbtn py-0"
                                                onClick={() => AddField("WhiteListUser")}
                                            >

                                                <RiAddBoxFill />
                                            </Button>

                                        </div>
                                    </div>

                                    {
                                        formdata?.WhiteListUser?.length > 0 ?
                                            formdata?.WhiteListUser.map((val, index) => (
                                                <div className="form-group mb-4" key={index}>
                                                    <label className="primary_label mb-2" htmlFor="name">
                                                        Enter Wallet Address
                                                    </label>
                                                    <div className="row first_row align-items-center">
                                                        <div className="col-11 mb-4 mb-lg-0">
                                                            <form>
                                                                <div class="form-group">
                                                                    <input
                                                                        type="text"
                                                                        class="form-control icon-email"
                                                                        id="WhiteListUser"
                                                                        aria-describedby="emailHelp"
                                                                        placeholder="Enter Wallet Address"
                                                                        onChange={(e) => OnChange(e, index)}
                                                                        value={val || ""}
                                                                    />
                                                                    {/* <input type="text" id="Whitelist" value={val||''} /> */}
                                                                    {Error["whitelist" + index] && (
                                                                        <span className="text-danger">
                                                                            {Error["whitelist" + index]}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </form>
                                                        </div>
                                                        <div className="col-1 d-flex justify-content-center">
                                                            <img
                                                                src={delete_png}
                                                                onClick={() => RemoveField(index, "WhiteListUser")}
                                                                alt="delete"
                                                                className="img-fluid delete_png"
                                                                width={30}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                            :
                                            <></>
                                    }
                                    {/* <div className="form-group position-relative mb-4">
                                        <input
                                            className={focusedfield?.includes('Password')
                                                ? (Error?.Password ? "form-control icon-password input-green-bd is-invalid"
                                                    : "form-control icon-password input-green-bd is-valid")
                                                : "form-control icon-password input-green-bd"}
                                            type={passwordType}
                                            name="Password"
                                            autocomplete="new-password"
                                            placeholder="Password"
                                            aria-required="true"
                                            // onChange={(e) => OnChange(e)}
                                            // onBlur={(e) => OnBlurFn(e)}
                                            id='Password'
                                        // value={formdata?.Password || ''}
                                        />
                                        <div onClick={togglePassword}>
                                            {passwordType == "text" ?
                                                <FaRegEye className="eyepassword" /> :
                                                <FaRegEyeSlash className="eyepassword"
                                                />}
                                        </div>

                                        {Error?.Password && (
                                            <span className="error-msg">{Error.Password}</span>
                                        )}
                                    </div>
                                    <div className="form-group position-relative mb-4">
                                        <input
                                            className={focusedfield?.includes('ConfirmPassword')
                                                ? (Error?.ConfirmPassword ? "form-control icon-password input-green-bd is-invalid"
                                                    : "form-control icon-password input-green-bd is-valid")
                                                : "form-control icon-password input-green-bd"}
                                            type={passwordType1}
                                            name="password_confirmation"
                                            placeholder="Confirm Password"
                                            aria-required="true"
                                            // onChange={(e) => OnChange(e)}
                                            // onBlur={(e) => OnBlurFn(e)}
                                            id='ConfirmPassword'
                                        // value={formdata?.ConfirmPassword || ''}
                                        />
                                        <div onClick={togglePassword1}>
                                            {passwordType1 === "text" ? <FaRegEye className="eyepassword" /> :
                                                <FaRegEyeSlash className="eyepassword" />}</div>
                                        {Error?.ConfirmPassword && (
                                            <span className="error-msg">{Error.ConfirmPassword}</span>
                                        )}
                                    </div> */}


                                    {/* <div className='d-flex align-items-center gap-3 mb-4'>
                                        <div className="custom_toggle">
                                            <label class="switch">
                                                <input
                                                    type="checkbox"
                                                    checked
                                                />
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                        <p className='mb-0 d-inline-block align-middle font-sm color-grey-500'>Lorem Ipsum</p>
                                    </div> */}

                                    <button className='btn btn-brand-lg btn-full font-md-bold mt-4' style={{ maxWidth: "200px" }} onClick={() => ProfileUpdate()} disabled={DisableStatus?.Update} type='button' >
                                        Update
                                    </button>


                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Subscriber />
            <Footer />
        </div>
    )
}

export default Profile